export type FieldRecap = {
  isUserField?: boolean;
  stepId?: string;
  label: string;
  name: string;
  value: string;
};

export type UseFormFieldsRecap = {
  fieldsRecap: Ref<FieldRecap[]>;
  isRecap: ComputedRef<boolean>;
};

export const useFormFieldsRecap = (step: Ref<any>): UseFormFieldsRecap => {
  const fieldsRecap = ref<FieldRecap[]>([]);

  const isRecap = computed(() => fieldsRecap.value.length > 0);

  const setFieldsRecap = (_recap: FieldRecap[]) => {
    fieldsRecap.value = _recap;
  };

  watchEffect(() => {
    setFieldsRecap(step.value?.recap || []);
  });

  return {
    fieldsRecap,
    isRecap,
  };
};
